import { __assign, __read } from "tslib";
import React, { useState, useEffect, useCallback, useRef } from 'react';
import classNames from 'classnames';
import isEqual from 'lodash.isequal';
import { useDefaultValue } from '@tencent/tea-component/lib/form/controlled';
import { Segment } from '@tencent/tea-component/lib';
import { Badge } from '@tencent/tea-component/lib/badge';
import { qcbuyUtils } from '@tencent/tcb-app';
import i18n from '../i18n';
var t = i18n.t;
function useCampare(value, compare) {
    var ref = useRef(null);
    if (!compare(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
}
export function BuyDiscount(props) {
    // null 表示不需要有按钮，true 表示收起状态，false 表示展开状态
    var _a = __read(useState(null), 2), moreButtonVisible = _a[0], setMoreButtonVisible = _a[1];
    var _b = useDefaultValue(props, ''), _c = _b.value, value = _c === void 0 ? '' : _c, onChange = _b.onChange, options = _b.options, _d = _b.isTimeSpan, isTimeSpan = _d === void 0 ? false : _d, _e = _b.isShowMore, isShowMore = _e === void 0 ? false : _e, _f = _b.onShowMoreClick, onShowMoreClick = _f === void 0 ? function () { } : _f;
    var hasBadge = options.some(function (_a) {
        var badge = _a.badge;
        return typeof badge !== 'undefined' && badge !== 100;
    });
    useEffect(function () {
        var isAllDefaultShow = props.options.every(function (_a) {
            var _b = _a.defaultShow, defaultShow = _b === void 0 ? true : _b;
            return defaultShow;
        });
        // 若全部都需要默认展示，则不需要有展开按钮
        if (isAllDefaultShow) {
            setMoreButtonVisible(null);
        }
        else {
            // 若至少有一个是默认收起，则需要展开按钮
            // 若不需要展开
            if (!isShowMore) {
                setMoreButtonVisible(true);
            }
            else {
                setMoreButtonVisible(false);
            }
        }
    }, [isTimeSpan, isShowMore, useCampare(options, isEqual)]);
    var newOnChange = useCallback(function (value, context) {
        if (!onChange) {
            return;
        }
        // 若点击的是「更多」按钮，则展示更多
        if (value === 'buy-segment-more') {
            onShowMoreClick();
            setMoreButtonVisible(false);
            return;
        }
        onChange(value, context);
    }, [onChange]);
    /**
     * 计算折扣信息 购买页框架下使用qcbuyUtils?.calcDiscount() 此方法仅用于tcb-sdk.pages页面示例展示
     * @param discountNum 计费后台返回的折扣数据（100以内的数字，100表示不打折）
     * @returns '约4.0折' | '4折' | 'about 40% off'
     */
    var localCalcDiscount = function (discountNum) {
        // number类型为折扣数据 100表示不打折
        if (typeof discountNum === 'number' && discountNum !== 100) {
            // 判断是否存在小数，存在加个“约”字，即：约 x.x 折
            var decimals = discountNum.toString().split('.')[1];
            // 向下取整 国内站: x.x折  国际站: (100-xx)% off
            var policy = i18n.language !== 'zh' ? 100 - Math.floor(discountNum) : Math.floor(discountNum) / 10;
            // “约”出的结果，折扣保留一位小数 eg: 40.1 = '约4.0折'  40 = '4折'
            var policyVal = decimals ? policy.toFixed(1) : policy;
            return decimals
                ? t('约{{ aboutPolicy }}折', { aboutPolicy: policyVal })
                : t('{{ policy }}折', { policy: policyVal });
        }
        return '';
    };
    var renderBadge = function (option) {
        var curBadge = option.badge;
        if (!curBadge)
            return;
        var badgeDisplay = '';
        // 允许字符串传入，例如: "售罄", 字符串类型直接展示
        if (typeof curBadge === 'string') {
            badgeDisplay = curBadge;
        }
        // number类型为折扣数据 100表示不打折
        if (typeof curBadge === 'number') {
            badgeDisplay = qcbuyUtils ? qcbuyUtils === null || qcbuyUtils === void 0 ? void 0 : qcbuyUtils.calcDiscount(curBadge) : localCalcDiscount(curBadge);
        }
        if (!badgeDisplay)
            return;
        return (React.createElement(Badge, { theme: "warning", dark: option.value === value || option.disabled }, badgeDisplay));
    };
    var newOptions = options;
    // 若要展示更多按钮，则只展示 defaultShow 为 true 的选项
    if (moreButtonVisible === true) {
        newOptions = newOptions.filter(function (_a) {
            var defaultShow = _a.defaultShow;
            return defaultShow;
        });
        newOptions.push({
            value: 'buy-segment-more',
            text: t('更多'),
        });
    }
    newOptions = newOptions.map(function (option) { return (__assign(__assign({}, option), { text: (React.createElement("div", null,
            option.text,
            renderBadge(option))) })); });
    return (React.createElement(Segment, { value: value, onChange: newOnChange, options: newOptions, className: classNames({
            'buy-segment-wrap': !isTimeSpan && !hasBadge,
            'buy-segment-discount': options.findIndex(function (_a) {
                var badge = _a.badge;
                return typeof badge !== 'undefined' && badge !== 100;
            }) !== -1,
            'tea-segment-time-length': isTimeSpan,
            'length-m': isTimeSpan && i18n.language !== 'zh',
        }) }));
}
//# sourceMappingURL=BuyDiscount.js.map